import sortCaseInsensitive from 'pages/utils/sort';
import Monitoring from 'shared_modules/Monitoring';

const formatOptions = vendors =>
  vendors
    .map(vendor => {
      const { vendorID, name } = vendor;
      return {
        value: vendorID,
        label: name,
      };
    })
    .sort((a, b) => sortCaseInsensitive(a.label, b.label));

export default formatOptions;

/**
 * Run a callback function after changing an option in the drop-down.
 * By passing a string, it's assumed the function is globally available in the window object.
 *
 * @param {string|function} callback
 * @param  {...any} args
 */
const runOnChangeCallbackFunc = (callback, ...args) => {
  const typeOfCallback = typeof callback;
  try {
    switch (typeOfCallback) {
      case 'function':
        callback(...args);
        break;
      case 'string':
        window[callback](...args);
        break;
      default:
        throw new Error(`${typeOfCallback} is not supported for callback function.`);
    }
  } catch (error) {
    Monitoring.NRError(error, 'runOnChangeCallbackFunc', { callback, ...args });
  }
};

export { runOnChangeCallbackFunc };
